export default __webpack_public_path__ + "static/assets/9f8ac3489e7c3a67cf89f869a572887f.png";